"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

const IMAGE_SRC = "/image/new-version/casting/Low-Pressure-Die-Casting/what-is-low-pressure-die-casting.webp";

const ITEMS = [
	{ subtitle: "whatIsLpdcSubtitle1", desc: "whatIsLpdcDesc1" },
	{ subtitle: "whatIsLpdcSubtitle2", desc: "whatIsLpdcDesc2" },
] as const;

const CheckIcon = () => (
	<span
		aria-hidden
		className="mt-0.5 inline-flex h-5 w-5 flex-none items-center justify-center rounded-full bg-[#64a525] text-white sm:h-[22px] sm:w-[22px]"
	>
		<svg
			viewBox="0 0 20 20"
			fill="none"
			stroke="currentColor"
			strokeWidth="3"
			strokeLinecap="round"
			strokeLinejoin="round"
			className="h-3 w-3 sm:h-3.5 sm:w-3.5"
		>
			<path d="M5 10.5l3.2 3.2L15 7" />
		</svg>
	</span>
);

export default function WhatIsLPDC() {
	const t = useTranslations("new-low-pressure-casting");

	return (
		<section className="bg-[#ffffff] py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<h2 className="mb-6 text-2xl font-bold leading-tight text-black sm:mb-8 sm:text-[30px] md:mb-10 md:text-4xl lg:mb-12">
					{t("whatIsLpdcTitle")}
				</h2>

				<div className="flex flex-col gap-8 lg:flex-row lg:items-start lg:gap-10">
					<div className="flex w-full flex-col lg:min-w-0 lg:flex-1">
						<div className="space-y-6">
							{ITEMS.map((item) => (
								<div key={item.desc} className="flex gap-3">
									<CheckIcon />
									<div className="min-w-0">
										<h3 className="text-base font-semibold text-black sm:text-lg">{t(item.subtitle)}</h3>
										<p className="mt-2 text-sm leading-relaxed text-black md:text-base">{t(item.desc)}</p>
									</div>
								</div>
							))}
						</div>
					</div>

					<div className="flex w-full lg:min-w-0 lg:flex-1">
						<div className="relative aspect-[4/2.3] w-full overflow-hidden shadow-lg">
							<Image
								src={IMAGE_SRC}
								alt={t("whatIsLpdcImageAlt")}
								fill
								className="object-cover"
								sizes="(max-width: 1024px) 100vw, 50vw"
							/>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
